"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FredhopperSegment = void 0;
var FredhopperSegment;
(function (FredhopperSegment) {
    FredhopperSegment["A"] = "a";
    FredhopperSegment["B"] = "b";
})(FredhopperSegment || (exports.FredhopperSegment = FredhopperSegment = {}));
//# sourceMappingURL=FredhopperSegmentEnums.js.map